module.exports = __webpack_public_path__ + "img/dollar.cbba86b7.svg";